const CollectionName = {
  CHAT_CHANNEL: 'chatChannel',
  CHAT_MESSAGE: 'chatMessage',
  CHAT_DRAFT_MESSAGE: 'chatDraftMessage',
  CHAT_MESSAGE_REQUEST: 'chatMessageRequest',
  CHANNEL_UNREAD_COUNT: 'channelUnreadCount',
  CHAT_THREAD_SEEN: 'chatThreadSeen',
  COACH: 'coach',
  SMART_CONTEXT_HISTORY: 'smartContextHistory',
  CLIENT_DOCUMENT: 'clientDocument',
};

export default CollectionName;
